import React, {PropTypes} from 'react';

import EmptyLabel from './EmptyLabel';
import FilledLabel from './FilledLabel';

const Label = ({
	canHover,
	data,
	index,
	onSelected
}) => {
	if(Object.keys(data).length === 0) {
		return <EmptyLabel index={index} onSelected={onSelected}/>;
	} else {
		return <FilledLabel canHover={canHover} imageUrl={data.imageUrl} index={index}/>;
	}
};

Label.propTypes = {
	canHover: PropTypes.bool.isRequired,
	data: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	onSelected: PropTypes.func.isRequired
};

export default Label;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/Label.js
 **/